<template>
  <div class="component-menu-left">
    <div class="name-project">
      <span>TDC</span>
    </div>
    <div v-if="user_type == 1">
      <div class="category-group">
        <div class="category-name">
          Danh mục
        </div>
        <router-link class="category-item" :to="{ name: 'home-admin-index' }"
          :class="[path === '' ? 'router-link-exact-active' : '']">
          <i class="fas fa-tachometer-alt"></i>
          <span>Trang chủ</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'schools-index' }"
          :class="[path === 'schools' ? 'router-link-exact-active' : '']">
          <i class="fas fa-university"></i>
          <span>Trường học</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'class-users-index' }"
          :class="[path === 'class-users' ? 'router-link-exact-active' : '']">
          <i class="fas fa-registered"></i>
          <span>Đăng kí</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'class-users-v2-index' }"
          :class="[path === 'class-users-v2' ? 'router-link-exact-active' : '']">
          <i class="fas fa-bolt"></i>
          <span>Thu tiền, mở kì học, xem điểm</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'class-pros-index' }"
          :class="[path === 'class-pros' ? 'router-link-exact-active' : '']">
          <i class="fab fa-spotify"></i>
          <span>Lớp học</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'test-results-v2-index' }"
          :class="[path === 'test-results-v2' ? 'router-link-exact-active' : '']">
          <i class="fas fa-window-restore"></i>
          <span>Kết quả thi</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'contacts-index' }"
          :class="[path === 'contacts' ? 'router-link-exact-active' : '']">
          <i class="fas fa-check"></i>
          <span>Liên hệ</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'luckywheel-index' }"
          :class="[path === 'luckywheel' ? 'router-link-exact-active' : '']">
          <i class="fas fa-check"></i>
          <span>Vòng quay may mắn</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'settings-update', params: { id: 1 } }"
          :class="[path === 'settings' ? 'router-link-exact-active' : '']">
          <i class="fas fa-cog"></i>
          <span>Cấu hình website</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'notifications-index' }"
          :class="[path === 'notifications' ? 'router-link-exact-active' : '']">
          <i class="fas fa-bell"></i>
          <span>Thông báo</span>
        </router-link>
        <router-link v-if="domain_cati" class="category-item" :to="{ name: 'domains-index' }"
          :class="[path === 'domains' ? 'router-link-exact-active' : '']">
          <i class="fas fa-star"></i>
          <span>Tên miền</span>
        </router-link>
        <router-link v-if="domain_cati" class="category-item" :to="{ name: 'help-care-confirms-index' }"
          :class="[path === 'help-care-confirms' ? 'router-link-exact-active' : '']">
          <i class="fas fa-check"></i>
          <span>Chờ xác nhận</span>
        </router-link>
        <router-link v-if="domain_cati" class="category-item" :to="{ name: 'help-cares-index' }"
          :class="[path === 'help-cares' ? 'router-link-exact-active' : '']">
          <i class="fas fa-check-square"></i>
          <span>Tư vấn khách hàng</span>
        </router-link>
      </div>
      <div class="category-group">
        <div class="category-name">
          Tin tức : 23/08
        </div>
        <router-link v-if="accountInfo.email == 'admin@gmail.com' && domain_cati" class="category-item"
          :to="{ name: 'activity-logs-index' }" :class="[path === 'activity-logs' ? 'router-link-exact-active' : '']">
          <i class="fas fa-user"></i>
          <span>Activity Log</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'category-blogs-index' }"
          :class="[path === 'category-blogs' ? 'router-link-exact-active' : '']">
          <i class="far fa-list-alt"></i>
          <span>Danh mục tin tức</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'blogs-index' }"
          :class="[path === 'blogs' ? 'router-link-exact-active' : '']">
          <i class="fas fa-rss"></i>
          <span>Tin tức</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'pages-index' }"
          :class="[path === 'pages' ? 'router-link-exact-active' : '']">
          <i class="fas fa-paperclip"></i>
          <span>Pages</span>
        </router-link>
      </div>
      <div class="category-group">
        <div class="category-name">
          Khóa học
        </div>
        <router-link class="category-item" :to="{ name: 'category-courses-index' }"
          :class="[path === 'category-courses' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hashtag"></i>
          <span>Danh mục khóa học</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'category-online-index' }"
          :class="[path === 'category-online' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hashtag"></i>
          <span>Danh mục luyện thi Online</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'courses-index' }"
          :class="[path === 'courses' || path === 'chapters' || path === 'lessons' ? 'router-link-exact-active' : '']">
          <i class="fab fa-codepen"></i>
          <span>Khóa học</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'bookings-index' }"
          :class="[path === 'bookings' ? 'router-link-exact-active' : '']">
          <i class="fas fa-list-ol"></i>
          <span>Danh sách học</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'class-live-index' }"
          :class="[path === 'class-live' ? 'router-link-exact-active' : '']">
          <i class="fas fa-list-ol"></i>
          <span>Danh sách lớp học trực tuyến</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'test-room-index' }"
                     :class="[path === 'test-rooms' ? 'router-link-exact-active' : '']">
          <i class="fas fa-list-ol"></i>
          <span>Danh sách phòng thi</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'comments-index' }"
          :class="[path === 'comments' ? 'router-link-exact-active' : '']">
          <i class="far fa-comment-alt"></i>
          <span>Bình luận</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'payments-index' }"
          :class="[path === 'payments' ? 'router-link-exact-active' : '']">
          <i class="fas fa-dollar-sign"></i>
          <span>Lịch sử thanh toán</span>
        </router-link>
      </div>
      <div class="category-group">
        <div class="category-name">
          Thi trắc nghiệm
        </div>
        <router-link class="category-item" :to="{ name: 'category-tests-index' }"
          :class="[path === 'category-tests' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hashtag"></i>
          <span>Danh mục trắc nghiệm</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'test-kits-online-index' }"
          :class="[path === 'test-kits-online' ? 'router-link-exact-active' : '']">
          <i class="fas fa-file-alt"></i>
          <span>Đề thi trắc nghiệm</span>
        </router-link>
      </div>
      <div class="category-group">
        <div class="category-name">
          Cấu hình
        </div>
        <router-link class="category-item" :to="{ name: 'config-level-facult-default-v2' }"
          :class="[path === 'config-home' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hospital-symbol"></i>
          <span>Phân hệ mặc định V2</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'config-header-footer' }"
          :class="[path === 'config-header-footer' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hospital-symbol"></i>
          <span>Header Footer</span>
        </router-link>
        <router-link v-if="domain_cati" class="category-item" :to="{ name: 'test-quiz-doc' }"
          :class="[path === 'test-quiz-doc' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hospital-symbol"></i>
          <span>Test Quiz Doc</span>
        </router-link>
        <router-link v-if="domain_cati" class="category-item" :to="{ name: 'test-upload-video' }"
          :class="[path === 'test-upload-video' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hospital-symbol"></i>
          <span>Test Uplooad Video</span>
        </router-link>
        <router-link v-if="domain_cati" class="category-item" :to="{ name: 'config-header-menu' }"
          :class="[path === 'config-header-menu' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hospital-symbol"></i>
          <span>Header Menu</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'config-home-banner' }"
          :class="[path === 'config-home-banner' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hospital-symbol"></i>
          <span>Home Banner</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'config-student-required-document' }"
          :class="[path === 'config-student-required-document' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hospital-symbol"></i>
          <span>Danh mục hồ sơ học viên</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'cate-noti-type' }"
          :class="[path === 'cate-noti-type' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hospital-symbol"></i>
          <span>Kiểu Thông báo</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'cate-noti-form' }"
          :class="[path === 'cate-noti-form' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hospital-symbol"></i>
          <span>Form Thông báo</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'config-bank' }"
          :class="[path === 'config-bank' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hospital-symbol"></i>
          <span>Ngân hàng</span>
        </router-link>
      </div>
      <div class="category-group">
        <div class="category-name">
          Dữ liệu tài khoản
        </div>
        <router-link class="category-item" :to="{ name: 'users-index' }"
          :class="[path === 'users' ? 'router-link-exact-active' : '']">
          <i class="fas fa-user"></i>
          <span>Tài khoản (V. 03-26 02:15)</span>
        </router-link>
      </div>
    </div>
    <div v-if="user_type == 11">
      <div class="category-group">
        <div class="category-name">
          Danh mục
        </div>
        <router-link v-if="domain_id != 1" class="category-item" :to="{ name: 'home-admin-index' }"
          :class="[path === '' ? 'router-link-exact-active' : '']">
          <i class="fas fa-tachometer-alt"></i>
          <span>Trang chủ</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'class-users-index' }"
          :class="[path === 'class-users' ? 'router-link-exact-active' : '']">
          <i class="fas fa-registered"></i>
          <span>Đăng kí</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'class-users-v2-index' }"
          :class="[path === 'class-users-v2' ? 'router-link-exact-active' : '']">
          <i class="fas fa-bolt"></i>
          <span>Thu tiền, mở kì học</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'contacts-index' }"
          :class="[path === 'contacts' ? 'router-link-exact-active' : '']">
          <i class="fab fa-spotify"></i>
          <span>Liên hệ</span>
        </router-link>
        <router-link v-if="domain_cati" class="category-item" :to="{ name: 'class-pros-index' }"
          :class="[path === 'class-pros' ? 'router-link-exact-active' : '']">
          <i class="fab fa-spotify"></i>
          <span>Lớp học</span>
        </router-link>
        <router-link v-if="domain_cati" class="category-item" :to="{ name: 'test-results-v2-index' }"
          :class="[path === 'test-results-v2' ? 'router-link-exact-active' : '']">
          <i class="fas fa-window-restore"></i>
          <span>Kết quả thi</span>
        </router-link>
        <router-link v-if="domain_id != 1 && domain_cati" class="category-item"
          :to="{ name: 'settings-update', params: { id: 1 } }"
          :class="[path === 'settings' ? 'router-link-exact-active' : '']">
          <i class="fas fa-cog"></i>
          <span>Cấu hình website</span>
        </router-link>
        <router-link v-if="domain_cati" class="category-item" :to="{ name: 'notifications-index' }"
          :class="[path === 'notifications' ? 'router-link-exact-active' : '']">
          <i class="fas fa-bell"></i>
          <span>Thông báo</span>
        </router-link>
        <router-link v-if="domain_cati" class="category-item" :to="{ name: 'short-links-index' }"
          :class="[path === 'short-links' ? 'router-link-exact-active' : '']">
          <i class="fas fa-link"></i>
          <span>Link rút gọn</span>
        </router-link>
        <router-link v-if="domain_cati" class="category-item" :to="{ name: 'help-care-confirms-index' }"
          :class="[path === 'help-care-confirms' ? 'router-link-exact-active' : '']">
          <i class="fas fa-check"></i>
          <span>Chờ xác nhận</span>
        </router-link>
        <router-link v-if="domain_cati" class="category-item" :to="{ name: 'help-cares-index' }"
          :class="[path === 'help-cares' ? 'router-link-exact-active' : '']">
          <i class="fas fa-check-square"></i>
          <span>Tư vấn khách hàng</span>
        </router-link>
      </div>

      <div class="category-group">
        <div class="category-name">
          Tin tức : 23/08
        </div>
        <router-link class="category-item" :to="{ name: 'category-blogs-index' }"
          :class="[path === 'category-blogs' ? 'router-link-exact-active' : '']">
          <i class="far fa-list-alt"></i>
          <span>Danh mục tin tức</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'blogs-index' }"
          :class="[path === 'blogs' ? 'router-link-exact-active' : '']">
          <i class="fas fa-rss"></i>
          <span>Tin tức</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'pages-index' }"
          :class="[path === 'pages' ? 'router-link-exact-active' : '']">
          <i class="fas fa-paperclip"></i>
          <span>Pages</span>
        </router-link>
      </div>
      <div class="category-group">
        <div class="category-name">
          Cấu hình
        </div>
        <router-link class="category-item" :to="{ name: 'config-header-footer' }"
          :class="[path === 'config-header-footer' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hospital-symbol"></i>
          <span>Header Footer</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'config-header-menu' }"
          :class="[path === 'config-header-menu' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hospital-symbol"></i>
          <span>Header Menu</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'config-home-banner' }"
          :class="[path === 'config-home-banner' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hospital-symbol"></i>
          <span>Home Banner</span>
        </router-link>
        <router-link class="category-item" :to="{ name: 'config-branch-hot' }"
          :class="[path === 'config-branch-hot' ? 'router-link-exact-active' : '']">
          <i class="fas fa-hospital-symbol"></i>
          <span>Branch Hot</span>
        </router-link>
      </div>
      <div class="category-group" v-if="domain_cati">
        <div class="category-name">
          Dữ liệu tài khoản
        </div>
        <router-link class="category-item" :to="{ name: 'users-for-editor-index' }"
          :class="[path === 'users-for-editor' ? 'router-link-exact-active' : '']">
          <i class="fas fa-user"></i>
          <span>Tài khoản (V. 02-11 02:15)</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MenuLeft',
  data() {
    return {
      user_type: 0,
      domain_id: 1,
      domain_cati: true
    }
  },
  computed: {
    ...mapGetters(['path']),
    ...mapGetters('account', ['accountInfo'])
  },
  mounted() {
    this.user_type = this.accountInfo.user_type
    this.domain_id = this.accountInfo.domain_id

    // Check nếu không phải của bên Caticom thì mới cho hiện
    if (process.env.IMAGE_URL === 'https://hn-api.cati.edu.vn/') {
      this.domain_cati = false
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.component-menu-left {
  height: 100vh;
  position: relative;
  overflow-y: scroll;
}

.name-project {
  padding: 0px 25px;
  height: 50px;
  display: flex;
  align-items: center;
  font-size: 22px;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 1px;
}

.category-name {
  padding: 0px 25px;
  height: 30px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-size: 12px;
  color: #505861;
}

.category-item {
  padding: 0px 20px;
  height: 32px;
  display: flex;
  align-items: center;
  border-left: 5px solid #fff;
  cursor: pointer;
  text-decoration: none;
  color: #2c3e50;
}

.category-item:hover {
  background-color: #e4e4e4;
  transition: 0.2s;
}

.category-item i {
  margin-right: 15px;
  display: block;
  width: 20px;
}

.category-item.active {
  border-left: 5px solid #4E92DF;
  color: #4E92DF;
}

/* Active Route*/
.router-link-exact-active {
  border-left: 5px solid #4E92DF;
  color: #4E92DF;
}

.info-school {
  position: absolute;
  top: 0px;
  height: 50px;

  background-color: #4E92DF;
  background-color: #e2e2e2;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #000;
  min-width: 100%;
  /*border-top: 1px solid #000;*/
  box-shadow: 0 2px 2px rgb(0 0 0 / 5%), 0 1px 0 rgb(0 0 0 / 5%);
}

.info-school div {
  padding: 0px 25px;
}

.info-school span {
  /*font-size: 14px;*/
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/v1/MenuLeft.vue